import { toJS } from 'mobx';
import { action } from 'mobx-angular';

export const traceWithValue = (msg: string) =>
  action(<T>(value: T): T => {
    const plain = toJS(value);
    console.log(msg, plain);
    return plain as T;
  });

export const trace = (msg: string) =>
  action(<T>(value: T): T => {
    console.log(msg);
    return toJS(value) as T;
  });
